export default __webpack_public_path__ + "static/kampane-3179aaefd6adf79c9fb7f662694fd9e7.png";